export async function captureViewport(): Promise<HTMLCanvasElement> {
  if (!navigator.mediaDevices?.getDisplayMedia) throw new Error('tab capture is unavailable')
  const stream = await navigator.mediaDevices.getDisplayMedia({
    video: { displaySurface: 'browser' }, audio: false,
    // Chromium hints: the browser still requires the reporter to confirm the tab.
    preferCurrentTab: true, selfBrowserSurface: 'include', surfaceSwitching: 'exclude',
  } as DisplayMediaStreamOptions)
  const video = document.createElement('video')
  video.muted = true
  video.playsInline = true
  video.srcObject = stream
  try {
    await video.play()
    if (!video.videoWidth || !video.videoHeight) await new Promise<void>((resolve, reject) => {
      video.addEventListener('loadedmetadata', () => resolve(), { once: true })
      video.addEventListener('error', () => reject(new Error('tab capture did not start')), { once: true })
    })
    if (!video.videoWidth || !video.videoHeight) throw new Error('tab capture has no pixels')
    const canvas = document.createElement('canvas')
    canvas.width = video.videoWidth
    canvas.height = video.videoHeight
    const context = canvas.getContext('2d')
    if (!context) throw new Error('canvas unavailable')
    context.drawImage(video, 0, 0)
    return canvas
  } finally {
    video.pause()
    video.srcObject = null
    stream.getTracks().forEach((track) => track.stop())
  }
}
